import React from "react";
import VerifyForm from "../components/forms/VerifyForm";
import Footer from "../components/layout/Footer";
import bgImage from "../assets/bg-login.jpg";
import logo from "../assets/logo2.png";

export default function Verify() {
  return (
    <>
      {/* Background section with logo and form */}
      <div
        className="min-h-screen flex flex-col bg-cover bg-center bg-no-repeat text-white"
        style={{ backgroundImage: `url(${bgImage})` }}
      >

        {/* Centered Verify Form */}
        <main className="flex-grow flex items-center justify-center px-4 z-10 mb-8">
          <div className="w-full max-w-md bg-white/95 bg-opacity-80 p-8 rounded-md shadow-lg text-black">
            <div className="flex justify-center mb-4">
              <a href="/">
                <img src={logo} alt="Logo" className="h-[50px]" />
              </a>
            </div>
            <h2 className="text-3xl font-bold mb-4">Verify Your Account</h2>
            <p className="text-sm text-gray-600 mb-6">
              Enter the verification code sent to your email.
            </p>
            <VerifyForm />
          </div>
        </main>
      </div>

      {/* Footer below background */}
      <Footer />
    </>
  );
}
